// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__AYbbe","Label":"BuildControl__Label__1U63H","Less":"BuildControl__Less__37Axx","More":"BuildControl__More__2IuVR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BuildControl/BuildControl.css
// module id = 121
// module chunks = 3